export const PEEKER_IDS = ['kid', 'cat', 'dog', 'moon'] as const
export type PeekerId = (typeof PEEKER_IDS)[number]

export const HIDE_IDS = ['bush', 'non-la', 'house', 'banana'] as const
export type HideId = (typeof HIDE_IDS)[number]

export const ANIMAL_IDS = [
  'chicken',
  'duck',
  'buffalo',
  'cat',
  'dog',
  'pig',
  'motorbike',
  'car',
] as const
export type AnimalId = (typeof ANIMAL_IDS)[number]

export const SHAPE_KINDS = ['circle', 'square', 'triangle'] as const
export type ShapeKind = (typeof SHAPE_KINDS)[number]

export const COLOR_KINDS = ['red', 'yellow', 'blue', 'green'] as const
export type ColorKind = (typeof COLOR_KINDS)[number]

export type ShapeArtKey = `${ShapeKind}-${ColorKind}`

export const COLOR_TRAY_COLORS = ['red', 'yellow', 'blue'] as const
export type ColorTrayColor = (typeof COLOR_TRAY_COLORS)[number]
